<div class="footer-bar">
  <p>Copyright © 2026 by Maksym Vasylyshyn <sup>®</sup></p>
</div>
